// extracted by mini-css-extract-plugin
export var chevronIcon = "_90-2";
export var teamName = "_90-1";
export var teamSwitcherButton = "_90-0";